import styled from "styled-components";
import defaultTheme from "@defaultTheme";

export const Container = styled.div`
  background-color: ${defaultTheme.colors.white};
  border-radius: 0.75rem;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
`;

export const Title = styled.div`
  font-weight: 600;
  padding: 1.5rem;
  font-size: ${defaultTheme.fontSize.g};
  line-height: 20px;
  letter-spacing: -0.02em;
  color: ${defaultTheme.colors.grey700};
  border-bottom: 1px solid ${defaultTheme.colors.grey70};
`;

export const Route = styled.div`
  padding: 1rem 0;
  margin: 0 1.5rem;
  border-bottom: 1px solid ${defaultTheme.colors.grey70};

  &:last-child {
    border: none;
  }

  & > div {
    margin-bottom: 6px;
  }

  & > div:first-child {
    margin-bottom: 9px;
    font-weight: 600;
    font-size: 15px;
    line-height: 22px;
    letter-spacing: -0.01em;

    & > span {
      color: ${defaultTheme.colors.grey700};
    }

    & > div {
      display: ${({ routeType }) => (routeType !== "" ? "block" : "none")};
      font-size: ${defaultTheme.fontSize.s};
      color: ${defaultTheme.colors.white};
      background-color: ${({ routeType }) =>
        routeType === "great"
          ? defaultTheme.colors.green600
          : routeType === "regular"
          ? defaultTheme.colors.orange500
          : defaultTheme.colors.red500};
      border-radius: 1rem;
      padding: 0.165rem 0.5rem 0.118rem 0.5rem;
      line-height: 19px;
    }
  }
`;

export const Row = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: ${defaultTheme.colors.grey500};
  font-size: ${defaultTheme.fontSize.m};
  line-height: 22px;
  letter-spacing: -0.01em;

  span:last-child {
    color: ${defaultTheme.colors.grey700};
    font-weight: 600;
  }
`;

export const Icon = styled.img`
  width: 18px;
  height: 18px;
  margin-right: -4px;
`;
